<a
  class="blog-card"
  [routerLink]="['/stories', item.slug]"
  [attr.aria-label]="'Lees het artikel ' + item.title"
  >
  @if (hasCover) {
    <div class="blog-card__media">
      <img
        [src]="item.coverImageUrl"
        [alt]="item.title"
        loading="lazy"
        referrerpolicy="no-referrer"
        />
      <div class="blog-card__media-overlay"></div>
    </div>
  }
  <div class="blog-card__body">
    <div class="blog-card__header">
      @if (item.categories.length) {
        <div class="blog-card__categories">
          @for (category of item.categories; track category) {
            <span class="blog-card__chip">
              {{ category.name }}
            </span>
          }
        </div>
      }
      @if (item.createdAt || item.publishedAt) {
        <span class="blog-card__date">
          {{ (item.createdAt || item.publishedAt) | date: 'd MMM yyyy' }}
        </span>
      }
    </div>
    <h3 class="blog-card__title">{{ item.title }}</h3>
    @if (item.excerpt) {
      <p class="blog-card__excerpt">{{ item.excerpt }}</p>
    }
    <div class="blog-card__footer">
      <span class="blog-card__cta">
        <span>Lees verder</span>
        <icon name="navigate_next" class="blog-card__cta-icon"></icon>
      </span>
    </div>
  </div>
</a>
